import { render, staticRenderFns } from "./WarenkorbArtikel.vue?vue&type=template&id=a29dc2b0"
import script from "./WarenkorbArtikel.vue?vue&type=script&lang=ts"
export * from "./WarenkorbArtikel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports